import type { Dictionary } from "./types";

export const en: Dictionary = {
  locale: {
    switcherLabel: "EN",
    fullName: "English",
  },
  nav: {
    links: {
      home: "Home",
      projects: "Projects",
      services: "Services",
      company: "Company",
      blogs: "Blogs",
      contactUs: "Contact Us",
      designs: "Designs",
      about: "About",
      career: "Career",
      faqs: "FAQs",
    },
    subItems: {
      developments: {
        label: "Developments",
        desc: "Website & Web Applications",
      },
      designs: {
        label: "Designs",
        desc: "Social media content, branding & more",
      },
      about: {
        label: "About",
        desc: "Who we are & how we work",
      },
      career: {
        label: "Career",
        desc: "Open roles & hiring process",
      },
      faq: {
        label: "FAQ",
        desc: "Answers to common questions",
      },
      contactUs: {
        label: "Contact Us",
        desc: "Get in touch with our team",
      },
    },
    menu: "Menu",
    exploreMore: "Explore More",
    bookMeeting: "Book a meeting",
    faqShort: "FAQ ?",
    servicesPanel: {
      creative: "Creative",
      development: "Development",
    },
  },
  footer: {
    description:
      "Build Web IT is a software development company that specializes serving businesses with digital solutions and graphic design. Our mission is to empower businesses with cutting-edge technology and exceptional user experiences.",
    contactUs: "Contact Us:",
    explore: "Explore",
    exploreLinks: {
      home: "Home",
      projects: "Projects",
      services: "Services",
      about: "About",
      careers: "Careers",
      writeReview: "Write a Review",
    },
    legal: "Legal",
    legalLinks: {
      termsAndConditions: "Terms & Conditions",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
    },
    socials: "Socials",
    allRightsReserved: "All rights reserved by Build Web IT © {year}",
  },
  legalPage: {
    contents: "Contents",
    effectiveDate: "Effective Date:",
    tocAriaLabel: "Table of contents",
    email: "Email:",
    phone: "Phone:",
  },
  home: {
    banner: {
      titleTop: "Smart solutions for modern businesses",
      title1: "We Build Digital Solutions,",
      title2: "To Grow Your Business Online",
      description:
        "At Build Web IT, we build websites that convert, design user-friendly experiences, and create online solutions that make it easier for your business to reach customers and grow.",
      reachOut: "Reach out",
    },
    services: {
      title: "Discover What We Can Build for You",
      description:
        "Our core services to design, develop, and grow your business.",
      weProvide: "We provide:",
      learnMore: "Learn more",
    },
    projects: {
      title: "Work We’re Proud Of",
      description: "A showcase of our best development work.",
      viewDetails: "View Details",
      live: "Live",
      seeAllProjects: "See All Projects",
    },
    designs: {
      title: "Designs Crafted with Passion",
      description:
        "Explore our creative works where imagination meets strategy to make brands truly stand out.",
      viewAll: "View All Designs",
    },
    skills: {
      eyebrow: "Our Tech Stack",
      title: "Our Expertise in Tools & Technologies",
      description:
        "At Build Web IT, we combine top tools and technologies with experience to deliver digital solutions that help your business succeed. Whether it’s creating stunning designs, building fast websites, or developing powerful apps, our team ensures every project is efficient, reliable, and tailored to your goals.",
      categories: {
        frontend: "Frontend",
        backend: "Backend",
        data: "Data & Cloud",
        design: "Design",
      },
    },
    team: {
      title: "Meet Our Co-Founders",
      description: "",
      designations: {
        "software-developer": "Software Developer",
        "graphics-designer": "Graphics Designer",
      },
    },
    workflow: {
      title: "See How We Work",
      description:
        "We follow 5 simple steps to build websites that match your business goals. From planning to launch, we make the process smooth and reliable.",
      stepLabel: "Step",
      steps: {
        consultation: {
          title: "Consultation",
          description:
            "We talk with you to understand your business, your goals, and what you need from your business solution or website.",
        },
        planningDesign: {
          title: "Planning & Design",
          description:
            "We create a simple plan, design the layout, and show you how the business system or website will look and work.",
        },
        development: {
          title: "Development",
          description:
            "We build your business solution or website using the latest tools and SEO best practices.",
        },
        testing: {
          title: "Testing",
          description:
            "We check everything carefully to make sure the business solution or website works smoothly on all devices.",
        },
        launchSupport: {
          title: "Launch & Support",
          description:
            "We launch your business solution or website and provide ongoing support to keep it updated and running well.",
        },
      },
    },
    bookAMeeting: {
      cardTitle: "When's a Good Time to Talk About Your Next Big Idea?",
      cardDescription:
        "We'd love to hear what you're working on — or dreaming about. Pick a 30-minute slot that works for you, and let's chat about how we can design, develop, and bring your vision to life. Your project could start today",
      sectionTitle: "Our process is simple, smooth and efficient.",
      steps: {
        initiateStrategy: {
          title: "Initiate a Strategy Session",
          description:
            "Engage with us in a consultative meeting to explore your business goals. We'll craft a tailored approach, define key objectives, establish timelines, and determine necessary resources.",
        },
        shapeTeam: {
          title: "Shape Your Dream Team",
          description:
            "Quickly solidify your project's blueprints, decide on a collaborative model, and seamlessly integrate our hand-picked experts with your vision.",
        },
        beginJourney: {
          title: "Begin Your Journey with Optimism",
          description:
            "Agree on pivotal goals, and we’ll get the ball rolling. Expect proactive updates as we align our progress with your evolving needs. Your satisfaction is our cue to excel.",
        },
      },
    },
    contact: {
      title: "Let's build together",
      description:
        "Have a project in mind? We are ready to create your website or design that helps your business grow. Tell us what you need and we will handle the rest.",
      contactTitle: "Prefer a call?",
      emailTitle: "Drop us a line at",
      letsGetStarted: "Let's Get Started",
      submit: "Submit",
      sending: "Sending…",
      successDefault: "Contact form submitted successfully!",
      errorDefault: "Failed to submit contact form.",
      requiredError: "{field} is required.",
      genericError: "Something went wrong. Please try again.",
      fields: {
        name: { label: "Your Name", placeholder: "Your name here" },
        email: { label: "Your Email", placeholder: "Your email here" },
        phone: {
          label: "Your Phone (Whatsapp Prefer)",
          placeholder: "Your phone here",
        },
        message: { label: "Message", placeholder: "Your message here" },
      },
    },
    faq: {
      title: "Frequently Asked Questions",
      description:
        "Find answers to the most common questions about our services.",
      viewAll: "View All FAQs",
    },
  },
  metadata: {
    keywords:
      "web development, graphic design, SEO-optimized websites, responsive websites, frontend developer, branding, creative design services, digital solutions, custom digital experiences, Build Web IT",
    ogLocale: "en_US",
    pages: {
      home: {
        title: "Build Web IT",
        description:
          "Build Web IT provides expert web development, graphic design, SEO-optimized and responsive websites, and custom digital solutions.",
        ogTitle:
          "Professional Web Development & Creative Design | Build Web IT",
        ogDescription:
          "Build Web IT crafts responsive, SEO-optimized websites and branding experiences for local and global clients.",
      },
      aboutUs: {
        title: "About Us",
        description:
          "Learn about Build Web IT's mission, vision, and dedicated team crafting custom web development, design, and digital solutions.",
        ogTitle: "About Build Web IT | Our Mission & Team",
        ogDescription:
          "Discover Build Web IT's mission, vision, and talented team delivering responsive websites, branding, and digital solutions worldwide.",
      },
      services: {
        title: "Services",
        description:
          "Explore Build Web IT's web development, product design, UI/UX design, and app design services. We craft responsive, SEO-optimized, and user-friendly digital solutions.",
        ogTitle: "Our Services | Build Web IT",
        ogDescription:
          "Build Web IT offers expert web development, UI/UX design, product design, and app design services for local and global clients.",
      },
      projects: {
        title: "Projects",
        description:
          "Explore Build Web IT's portfolio of e-commerce, business, and service-based websites built with modern, responsive, and SEO-friendly design.",
        ogTitle: "Our Projects | Build Web IT",
        ogDescription:
          "Browse Build Web IT's work — e-commerce, business, and portfolio websites built to be fast, accessible, and conversion-focused.",
      },
      projectsDetail: {
        title: "Project",
        description: "Explore our project case studies in depth.",
      },
      designs: {
        title: "Designs",
        description:
          "Explore Build Web IT's creative graphic design portfolio — brand identity, packaging, editorial, and social media visuals.",
        ogTitle: "Our Designs | Build Web IT",
        ogDescription:
          "Creative graphic design work by Build Web IT — brand identity, packaging, editorial, and social-first visuals.",
      },
      contactUs: {
        title: "Contact Us",
        description:
          "Get in touch with Build Web IT. We'd love to hear about your project — drop us a line and we'll get back to you quickly.",
        ogTitle: "Contact Build Web IT",
        ogDescription:
          "Send us a message about your web development, design, or digital solution project — we'll respond fast.",
      },
      careers: {
        title: "Careers",
        description:
          "Explore career opportunities at Build Web IT. Join a growing team building responsive, SEO-friendly, and user-focused digital products.",
        ogTitle: "Careers at Build Web IT",
        ogDescription:
          "Open roles and hiring process at Build Web IT — join us to build standout web and design experiences.",
      },
      careersDetail: {
        title: "Careers",
        description: "Explore our portfolio of Ecommerce and Service Based websites",
      },
      testimonials: {
        title: "Testimonials",
        description:
          "Read what Build Web IT's clients say about our web development, design, and digital solutions.",
        ogTitle: "Testimonials | Build Web IT",
        ogDescription:
          "Real client feedback on Build Web IT's web development and design work.",
      },
      writeReview: {
        title: "Write a Review",
        description:
          "Share your experience working with Build Web IT — your review helps others find a trusted web and design partner.",
        ogTitle: "Write a Review | Build Web IT",
        ogDescription:
          "Tell us how we did — your review helps future clients learn about Build Web IT.",
      },
      faq: {
        title: "FAQ",
        description:
          "Find clear answers to common questions about Build Web IT’s services, pricing, timelines, process, maintenance, and support.",
        ogTitle: "FAQ | Build Web IT",
        ogDescription:
          "Everything you need to know about working with Build Web IT — services, project scope, costs, timelines, and ongoing support.",
      },
      blogs: {
        title: "Blogs",
        description:
          "Read the Build Web IT blog for insights on web development, design, SEO, and building better digital products.",
        ogTitle: "Build Web IT Blog",
        ogDescription:
          "Insights, tutorials, and stories on web development, design, and growing digital products from Build Web IT.",
      },
      bookAMeeting: {
        title: "Book a Meeting",
        description:
          "Schedule a 30-minute meeting with Build Web IT to discuss your project goals, timeline, and how we can help.",
        ogTitle: "Book a Meeting | Build Web IT",
        ogDescription:
          "Pick a slot that works for you and let's chat about your project — Build Web IT.",
      },
      termsAndConditions: {
        title: "Terms & Conditions",
        description:
          "Read the Terms & Conditions for using Build Web IT's website and services — scope, payments, revisions, intellectual property, and more.",
        ogTitle: "Terms & Conditions | Build Web IT",
        ogDescription:
          "The terms that govern your use of Build Web IT's website and our web, app, and design services.",
      },
      privacyPolicy: {
        title: "Privacy Policy",
        description:
          "Learn how Build Web IT collects, uses, shares, and protects your personal information, and the rights you have over your data.",
        ogTitle: "Privacy Policy | Build Web IT",
        ogDescription:
          "How Build Web IT handles your data — what we collect, why, how we protect it, and your privacy rights.",
      },
      cookiePolicy: {
        title: "Cookie Policy",
        description:
          "Understand how Build Web IT uses cookies and similar technologies, the types of cookies we use, and how you can manage them.",
        ogTitle: "Cookie Policy | Build Web IT",
        ogDescription:
          "How Build Web IT uses cookies, why we use them, and how you can control them in your browser.",
      },
    },
  },
  // NOTE: every `blurb` below is intentionally exactly 12 words AND
  // contains NO hyphenated compound words — that way the count is
  // 12 whether a reader treats "Goal-driven" as one word or two.
  // Every entry in `items` is intentionally exactly 2 words. Keeping
  // these counts uniform makes the home service cards line up
  // visually — same description height, same bullet rhythm — across
  // all locales. If you edit copy here, please preserve the counts
  // and the no-hyphen rule (and mirror the change in `bn.ts`).
  homeServiceCards: {
    ecommerce: {
      title: "Ecommerce",
      blurb:
        "Storefronts focused on conversion with smooth checkout, simple catalogs, and friendly content.",
      shortBlurb:
        "Storefronts that convert—fast, scalable, and easy to manage.",
      items: [
        "Product Catalog",
        "Search Filters",
        "Smooth Checkout",
        "Secure Payments",
        "Order Tracking",
        "Sales Analytics",
      ],
    },
    landing: {
      title: "Landing Page",
      blurb:
        "Sharp campaign and launch pages with modular sections, built to ship fast.",
      shortBlurb:
        "Launch pages that load fast, tell the story, and convert.",
      items: [
        "Brand Narrative",
        "Hero Section",
        "Modular Layout",
        "Conversion Hooks",
        "Lead Forms",
        "SEO Schema",
      ],
    },
    custom: {
      title: "Custom Website",
      blurb:
        "Modern websites that load fast, stay accessible, and are easy to manage.",
      shortBlurb: "Tailored, fast, accessible websites you can manage.",
      items: [
        "Business Sites",
        "Portfolio Pages",
        "Blog Platforms",
        "Service Listings",
        "Restaurant Menus",
        "Real Estate",
      ],
    },
    mobileApp: {
      title: "Mobile App",
      blurb:
        "Native iOS and Android apps with smooth UX and reliable, clean architecture.",
      shortBlurb: "Fast, reliable iOS & Android apps built to scale.",
      items: [
        "iOS Development",
        "Android Development",
        "React Native",
        "Push Notifications",
        "Offline Support",
        "App Stores",
      ],
    },
    uiux: {
      title: "UI/UX Design",
      blurb:
        "Clean interfaces designed around your users with validated flows and accessible patterns.",
      shortBlurb:
        "User-friendly interfaces backed by research and design systems.",
      items: [
        "User Research",
        "Wireframe Designs",
        "Design Systems",
        "Interactive Prototypes",
        "Usability Testing",
        "WCAG Compliance",
      ],
    },
  },
  navServiceCategoryItems: {
    creative: {
      webDesign: {
        name: "Web design",
        shortDescription: "Creating beautiful and functional websites",
      },
      brandIdentity: {
        name: "Brand identity",
        shortDescription: "Logos, color systems, and brand guidelines",
      },
      graphicDesign: {
        name: "Graphic design",
        shortDescription: "Marketing visuals for web and print",
      },
    },
    development: {
      webDevelopment: {
        name: "Web development",
        shortDescription: "Building responsive and functional websites",
      },
      mobileAppDevelopment: {
        name: "Mobile app development",
        shortDescription: "Native and cross-platform iOS & Android apps",
      },
      ecommerceSolutions: {
        name: "Ecommerce Solutions",
        shortDescription: "Developing online stores and shopping experiences",
      },
    },
  },
  projectDetail: {
    fallbackTitle: "Project Details",
    liveDemo: "Live Demo",
    mockupImageAlt: "Mockup Image",
    largeImageAlt: "Large Image",
    landingImageAlt: "Landing",
  },
  projectsList: {
    headerTitle: "See the Results for Yourself — Our Work Says It All",
    headerDescription:
      "We make it effortless for you by handling everything from start to finish, with a dedicated team focused on delivering real results — not just promises.",
    filterAll: "All",
    categories: {
      ecommerce: "E-commerce",
      development: "Custom Development",
      creative: "Social Media Content",
      webdesign: "Web Design",
      portfolio: "Portfolio",
    },
  },
  blogsList: {
    filterAll: "All",
    readMore: "Read More",
    sidebar: {
      categoriesHeader: "Categories",
      categories: {
        productivity: "Productivity",
        development: "Development",
        uiUx: "UI/UX",
        tutorials: "Tutorials",
      },
    },
    mediumLogoAlt: "Medium Logo",
    linkedinLogoAlt: "LinkedIn Logo",
    blogImageAlt: "Blog Image",
  },
  notFound: {
    title: "Page Not Found",
    description:
      "Sorry, the page you’re looking for doesn’t exist or has been moved.",
    goHome: "Go Back Home",
  },
  bookMeeting: {
    calendarLabel: "Calendar",
    timezoneLabel: "Time zone",
    timezoneSelected: "Selected:",
    timezonePlaceholder: "Select your time zone",
    timezoneChanged: "Time zone changed. Please re-select your date & time.",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    availableTimes: "Available times",
    each: "each",
    pickDateHint: "Pick a date to see available slots.",
    noFutureSlots: "No future times remain today in {timezone}.",
    enterYourDetails: "Enter your details",
    yourSelection: "Your selection",
    chooseDateTimeFirst: "Choose a date & time first",
    youSelected: "You selected",
    changeTime: "← Change time",
    bookButton: "Book meeting",
    booking: "Booking…",
    reset: "Reset",
    meetingConfirmed: "Meeting confirmed!",
    confirmedMessage: "We'll get back to you within 24 hours.",
    bookAnother: "Book another",
    selected: "Selected",
    select: "Select",
    confirm: "Confirm",
    continueLabel: "Continue",
    requiredSuffix: "*",
    fields: {
      name: { label: "Your Name *", placeholder: "Your name here" },
      phone: {
        label: "Your Phone (WhatsApp preferred) *",
        placeholder: "Your phone here",
      },
      email: { label: "Your Email *", placeholder: "Your email here" },
      message: {
        label: "Tell us briefly what you'd like to discuss *",
        placeholder: "What would you like to discuss?",
      },
    },
    weekdays: {
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
    },
  },
  pagination: {
    label: "Pagination",
    previous: "Previous page",
    next: "Next page",
  },
  careerDetail: {
    backToList: "← Back to job list",
    context: "Job Context:",
    requirements: "Job Requirements:",
    additionalRequirements: "Additional Job Requirements:",
    educationalRequirements: "Educational Requirements:",
    benefits: "Benefits:",
    applicationDeadline: "Application Deadline:",
    skills: "Skills",
    jobLocation: "Job Location:",
    emailYourCv: "Email Us Your CV / Resume:",
    deadlinePassed:
      "We are no longer accepting new applications for this position as the job application deadline is over!",
  },
  designsPage: {
    title: "Designs Crafted with Passion",
    description:
      "Explore our creative works where imagination meets strategy to make brands truly stand out.",
  },
  blogsPage: {
    title: "Discover the latest in web design and develpment",
    description:
      "From tutorials to industry insights, our blog has everything you need to stay ahead. Subscribe for updates and never miss out!",
  },
  writeReviewPage: {
    pageTitle: "Share Your Testimonial",
    pageDescription:
      "Tell others about your experience. Your words help future clients.",
    formTitle: "Leave a Testimonial",
    fields: {
      name: {
        label: "Your Name",
        placeholder: "Jane Doe",
        required: "Your name is required.",
      },
      designation: {
        label: "Your Designation (optional)",
        placeholder: "CTO, Product Manager…",
      },
      company: {
        label: "Company (optional)",
        placeholder: "Acme Inc.",
      },
      content: {
        label: "Share your Experience",
        placeholder: "Share your experience working with us…",
        required: "Please write your experience.",
      },
      rating: {
        legend: "Your Rating",
        rangeError: "Rating must be between 1 and 5.",
      },
    },
    submit: "Submit Testimonial",
    submitting: "Submitting...",
    successTitle: "Submitted!",
    successMessage: "Thanks for your review",
    successCta: "Great",
    errorTitle: "Submission failed",
    errorMessage: "Failed to submit review.",
    errorCta: "Close",
  },
  careersPage: {
    banner: {
      title: "Careers",
      description:
        "Have a zeal of creating real world and credible impact in business and consumer experience everyday using technology.",
    },
    whyJoinUs: {
      title: "Why Join Us",
      joinUsCta: "Join Us",
      points: {
        fastGrowing: {
          title: "Fast growing company",
          description:
            "Join a dynamic team that is expanding rapidly with exciting new projects.",
        },
        greatColleagues: {
          title: "Great colleagues & support",
          description:
            "Work with a supportive team that fosters collaboration and growth.",
        },
        keepLearning: {
          title: "Don’t stop learning",
          description:
            "Access continuous learning opportunities to enhance your skills.",
        },
        latestStack: {
          title: "Latest Technology stack",
          description:
            "Utilize cutting-edge tools and technologies in your daily work.",
        },
        takeCharge: {
          title: "Take charge",
          description: "Lead initiatives and take ownership of your projects.",
        },
        crossDomain: {
          title: "Cross domain exposure",
          description:
            "Gain experience across various domains to broaden your expertise.",
        },
      },
    },
    jobPost: {
      sectionTitle: "Open Positions",
      applyNow: "Apply Now",
      deadlineLabel: "Deadline:",
      noJobs: "No Job Posts Available",
      noJobsHint:
        "There are currently no open positions. Please check back later.",
    },
  },
  servicesPage: {
    hero: {
      titleLine1: "Professional",
      titleLine2: "Web Services",
      description:
        "Transform your digital presence with our comprehensive suite of web development and design services",
      exploreCta: "Explore Our Services",
    },
    letsTalk: "Let's Talk",
    cta: {
      title: "Ready to Get Started?",
      description:
        "Let's discuss your project and create something amazing together. Our team is ready to bring your vision to life.",
      button: "Start Your Project",
    },
    services: {
      ecommerce: {
        title: "Ecommerce",
        bannerDescription:
          "We create ecommerce websites that are secure, fast, and easy to manage for selling products online.",
        description:
          "We build ecommerce websites that help you sell products online with simple management and smooth user experience.",
        subServices: [
          "Custom shopping cart & checkout",
          "Secure payment integration",
          "Order & Shipping Management",
          "Analytics & Sales Reporting & Custom Requirements",
        ],
      },
      landing: {
        title: "Landing Page",
        bannerDescription:
          "Campaign and product launch pages with sharp messaging, modular sections, and performance budgets built to ship and iterate fast.",
        description:
          "We create landing pages that load fast, look professional, and help increase your conversions.",
        subServices: [
          "Lightning-fast performance",
          "SEO-optimized architecture",
          "Pixel-perfect convertion from Figma to Code",
          "User Friendly Interface",
        ],
      },
      mobileApp: {
        title: "Mobile App",
        bannerDescription:
          "We build mobile apps for iOS and Android that are fast, reliable, and easy for your customers to use.",
        description:
          "We design and develop mobile apps tailored to your business — with a smooth user experience, secure architecture, and full launch support on the App Store and Play Store.",
        subServices: [
          "Native iOS development",
          "Native Android development",
          "Cross-platform (React Native / Flutter)",
          "API & backend integration",
          "Push notifications & offline support",
          "App Store & Play Store launch",
        ],
      },
      custom: {
        title: "Custom Website",
        bannerDescription:
          "We build custom websites that match your business needs and give you full control over features and design.",
        description:
          "We create custom websites tailored for your business with responsive design and easy management.",
        subServices: [
          "Tailored Design & Functionality",
          "SEO Optimization",
          "Fast & Secure",
          "Responsive & Mobile Friendly",
        ],
      },
      uiux: {
        title: "UI/UX",
        bannerDescription:
          "We design user-friendly interfaces and experiences that make your website or app simple to use.",
        description:
          "We focus on UI/UX design that improves usability and creates a better experience for your users.",
        subServices: [
          "Modern visual design",
          "Design sytem creation",
          "User research & testing",
          "User Friendly Interface",
        ],
      },
    },
  },
  aboutUs: {
    banner: {
      title: "About Us",
      description: "Learn more about our team and mission",
    },
    focus: {
      mission: {
        title: "Our Mission",
        description:
          "Our mission is simple: We want to establish unique and highly effective online results for our clients.",
      },
      vision: {
        title: "Our Vision",
        description:
          "We envision a world where technology seamlessly enhances business operations, not hampering creativity and efficiency. We want to simplify complex techniques and operational processes with the help of modern technologies.",
      },
      why: {
        title: "Why We Do It",
        description:
          "Because we believe every business deserves the chance to grow, compete, and succeed. The digital world is full of opportunities, and we’re passionate about helping brands make their mark, increase visibility, and achieve long-term success.",
      },
      how: {
        title: "How We Do It",
        description:
          "We combine technology, creativity, and strategy to craft tailored digital solutions. From high-performance websites and SEO strategies to branding and marketing campaigns, we analyze, optimize, and implement what works best for your business—ensuring maximum impact and ROI.",
      },
    },
    whyChooseUs: {
      title: "Why Choose Us?",
      description:
        "At Build Web IT, we believe your success is our success. Here’s why clients trust us:",
      points: {
        experiencedTeam: {
          title: "Experienced Team",
          description:
            "Our skilled developers, designers, and strategists bring years of hands-on experience to every project.",
        },
        customSolutions: {
          title: "Custom Solutions",
          description:
            "We create software and digital products tailored to your unique business needs.",
        },
        endToEndService: {
          title: "End-to-End Service",
          description:
            "From idea to launch, we handle everything—design, development, deployment, and support.",
        },
        onTimeDelivery: {
          title: "On-Time Delivery",
          description:
            "We value your time and ensure projects are completed within deadlines without compromising quality.",
        },
        affordableTransparent: {
          title: "Affordable & Transparent",
          description:
            "Clear pricing with no hidden costs, so you know exactly what you’re paying for.",
        },
        longTermPartnership: {
          title: "Long-Term Partnership",
          description:
            "We don’t just build projects; we build relationships for lasting growth.",
        },
      },
    },
    departments: {
      title: "Meet the Team working behind the Scenes",
      items: {
        development: {
          title: "Development",
          description:
            "Our development team builds robust, scalable, and secure applications that meet your business needs. Our developers are specialized in web and mobile app development and web app development ensuring your digital products are high-performing and user-friendly.",
        },
        design: {
          title: "Graphic Design",
          description:
            "Our design team creates visually stunning and user-friendly interfaces that enhance user experience. We focus on creating designs that are not only aesthetically pleasing but also functional and intuitive. Branding is at the core of what we do, and our designers ensure your brand stands out in the digital landscape.",
        },
        management: {
          title: "Project Planning & Management",
          description:
            "Our project managers ensure that every project runs smoothly from start to finish. They coordinate between teams, manage timelines, and ensure that your project is delivered on time and within budget. Our project management approach is transparent and collaborative, keeping you informed every step of the way.",
        },
        support: {
          title: "Customer Support",
          description:
            "Our customer support team is here to assist you with any questions or issues you may have. We believe in providing exceptional customer service and support, ensuring that your experience with us is smooth and hassle-free. Our support team is available to help you with everything from project inquiries to technical support.",
        },
      },
    },
  },
  faqPage: {
    label: "FAQ",
    title: "Frequently Asked Questions",
    description:
      "Find answers to the most common questions about our services.",
    categories: {
      general: {
        title: "General Questions",
        questions: {
          services: {
            q: "What services do you provide?",
            a: "We provide web development, app design, UI/UX design, and product design. We can also redesign existing websites, fix errors, and set up hosting and domain if you need it.",
          },
          whyChoose: {
            q: "Why should I choose Build Web IT?",
            a: "We are a budget-friendly IT company from Bangladesh. We always deliver work on time, update clients every day about progress, and make sure the final product is user-friendly, responsive, and SEO-ready.",
          },
          smallLarge: {
            q: "Do you work on both small and large projects?",
            a: "Yes, we handle projects of any size. We can work on small tasks like bug fixing or full projects like websites, apps, or product designs.",
          },
          seoFriendly: {
            q: "Is your work SEO friendly?",
            a: "Yes. We focus on SEO from the beginning, adding proper information and structure to help your website rank better on search engines like Google.",
          },
        },
      },
      development: {
        title: "Development Questions",
        questions: {
          types: {
            q: "What type of websites can you build?",
            a: "We can build business websites, eCommerce websites, portfolio websites, blogs, and custom web apps. All websites are responsive and work on mobile, desktop, and tablet.",
          },
          redesign: {
            q: "Can you redesign my existing website?",
            a: "Yes, we can redesign your old website to make it modern, fast, mobile-friendly, and SEO-ready.",
          },
          fixErrors: {
            q: "Do you fix errors on existing websites?",
            a: "Yes, we can fix technical issues, errors, bugs, and performance problems on your current website.",
          },
          hosting: {
            q: "Do you provide hosting and domain?",
            a: "Yes, if you have the budget, we can set up hosting and domain for your website. Otherwise, we can guide you on how to get it.",
          },
        },
      },
      design: {
        title: "Design Questions",
        questions: {
          productDesign: {
            q: "What is product design?",
            a: "Product design means creating simple and user-friendly digital products. This can include designing layouts, flows, and user experiences for apps or websites that solve real problems for users.",
          },
          androidIos: {
            q: "Do you design apps for both Android and iOS?",
            a: "Yes, we design mobile apps that work for both Android and iOS. Our designs are simple, easy to use, and focused on your business goals.",
          },
          uiVsUx: {
            q: "What is the difference between UI and UX design?",
            a: "UI design means the look of the app or website (colors, fonts, buttons). UX design means how the user uses it (easy navigation, smooth flow). We provide both UI and UX design together.",
          },
          customBrand: {
            q: "Can you create custom designs for my brand?",
            a: "Yes, we can create designs that match your brand style, logo, and business needs. We make sure the design looks professional and user-friendly.",
          },
        },
      },
      process: {
        title: "Process & Delivery Questions",
        questions: {
          startProject: {
            q: "How do you start a new project?",
            a: "We first talk with you to understand your requirements. Then we explain the time and cost. After you agree, we start working and keep you updated every day.",
          },
          contentReady: {
            q: "Do I need to have all the content ready before starting?",
            a: "No, you don’t need everything ready. We can start with the main content and later collect the remaining while working on the project.",
          },
          revisions: {
            q: "How do you handle revisions?",
            a: "We mostly provide 3 revisions included in the project. After that, extra revisions will cost an additional charge. All revisions are discussed through online meetings.",
          },
          cost: {
            q: "How much does a project cost?",
            a: "The cost depends on the size and type of the project. We offer custom pricing based on your needs and budget. We always try to stay budget-friendly.",
          },
          timeline: {
            q: "How long does it take to complete a project?",
            a: "The time depends on the project size. Small websites can take a few days, while big projects may take weeks. We always give you a clear timeline before starting.",
          },
        },
      },
    },
  },
};
